import React from 'react';
import {
  ActionIcon, ICON_ARROW_UP, ModalSize, Portal, useModal,
} from '@doveit/bricks';
import { Widget as TypeformWidget } from '@typeform/embed-react';
import { Feedback } from '../../../providers/api/dtos';
import useRBAC from '../../../hooks/use-rbac/useRBAC';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { FeedbackStatus } from '../../../domain/types';

interface ChildFnProps {
  startSurvey: VoidFunction,
}

export interface StartSurveyActionProps extends React.AriaAttributes {
  feedback: Feedback,
  children?: (props: ChildFnProps) => React.ReactNode,
  onSubmit?: (surveyId: string) => void,
}

const StartSurveyAction: React.FC<StartSurveyActionProps> = ({
  feedback,
  children,
  onSubmit,
  ...rest
}) => {
  const modal = useModal();
  const { user } = useRBAC();

  const handleSubmit = React.useCallback(({ formId }: { formId: string }) => {
    modal.close();

    onSubmit?.(formId);
  }, [modal, onSubmit]);

  if (feedback.status !== FeedbackStatus.TODO) {
    return null;
  }

  return (
    <>
      {children
        ? children({ startSurvey: () => modal.open() })
        : (
          <ActionIcon
            {...rest}
            icon={{ path: ICON_ARROW_UP, direction: 'right' }}
            emphasis="high"
            size="S"
            aria-label="Avvia survey"
            label="Avvia survey"
            onClick={() => modal.open()}
          />

        )}
      <Portal>
        <SimpleModal
          {...modal}
          size={ModalSize.XLARGE}
          fillAvailableHeight
          padded={false}
          title={`Survey: "${feedback.survey!.name}"`}
          aria-label={`Modale per compilare la survey ${feedback.survey!.name}`}
        >
          <TypeformWidget
            disableScroll
            id={feedback.survey!.id}
            style={{ width: '100%', height: '100%' }}
            onSubmit={handleSubmit}
            hidden={{
              feedback_id: feedback.id!!,
              operator: user.email,
            }}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default StartSurveyAction;
